import React from "react"
import styled from "styled-components"

import Layout from "../components/layout"

import Title from "@airasia/phoenix-components/components/Title"
import Text from "@airasia/phoenix-components/components/Text"
import FAQ from "@airasia/phoenix-widgets/widgets/FAQ"

import { GTM_EVENT_CATEGORY } from "../utils/constants"

import LOCATIONS from "../data/internalLinks/locations.json"
import CarouselCard from "../components/carousel"
import InternalLinkingBlock from "../components/internalLinkingBlock"
import LocationCarousel from "../components/locationCarousel"

import getInternalLinksForTemplate from "../utils/internalLinkGeneration"
import ExpandableContentBlock from "../components/expandableContentBlock"
// const CarouselCard = loadable(() => import("../components/carousel"))

const ContentWrapper = styled.div`
  margin: 5% 16px;

  @media only screen and (min-width: 720px) {
    margin: 2% 8px;
  }
`

const TextWrapper = styled.div`
  border-style: solid;
  padding: 0px 8px 8px 8px;
  border-width: thin;
  border-color: gray;
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 1px;
  border-radius: 8px;
  background-color: rgb(255, 255, 255);
  border: 1px solid rgb(213, 217, 226);
`

const LocationPage = props => {
  const {
    data,
    metaTags,
    content,
    pageHeading,
    layout,
    additionalInternalLinks,
    locationFaq,
  } = props.pageContext

  const { pageComponentTranslation } = layout
  const { id, location, countryId } = data

  // countryId will be null for Country template
  let countryIdForInternalLinks =
    countryId !== "undefined" ? countryId : id

  const carouselHeadings = content.carousel_headings || {}
  const internalLinkHeadings = content.internalLinkHeadings || {}

  const contentBlock = content.content_block ? (
    <ContentWrapper>
      <ExpandableContentBlock
        contentBlock={content.content_block}
        translations={pageComponentTranslation.contentBlock}
      />
    </ContentWrapper>
  ) : null

  // faq
  const faqObjects = locationFaq.faq
  const faqBlockTitle = locationFaq.blockTitle

  // Internals Links
  const {
    HotelsListByRating,
    HotelsListByBudget,
    HotelsListByDiscount,
    HotelsListGeneral,
  } = props.pageContext.carouselData

  const internalLinks = getInternalLinksForTemplate({
    template: layout.configuration.template_type,
    internalLinkFile: LOCATIONS,
    internalLinkHeadings,
    countryId: parseInt(countryIdForInternalLinks),
    translations: pageComponentTranslation.internalLink,
    localeUrlSuffix: layout.configuration.url_suffix,
  })

  // additional internal links
  const locationCarousels = additionalInternalLinks.carousels.map(carousel => {
    return (
      <LocationCarousel data={carousel} gtmConsumerName={carousel.purpose} />
    )
  })

  const additionalInternalLinkBlocks = additionalInternalLinks.internalLinkBlocks.map(
    block => {
      return (
        <ContentWrapper>
          <InternalLinkingBlock
            blockTitle={block.headline}
            linkObjects={block.internal_links}
            gtmConsumerName={GTM_EVENT_CATEGORY.COUNTRY_LOCATION}
          />
        </ContentWrapper>
      )
    }
  )

  return (
    <Layout
      pageData={{
        data,
        metaTags,
        pageHeading,
        layout,
        faq: faqObjects,
      }}
    >
      {HotelsListGeneral.length ? (
        <CarouselCard
          headline={carouselHeadings.general}
          data={HotelsListGeneral}
          location={location}
          gtmConsumerName={GTM_EVENT_CATEGORY.GENERAL}
          translations={pageComponentTranslation.carousel}
        />
      ) : null}

      {HotelsListByBudget.length ? (
        <CarouselCard
          headline={carouselHeadings.budget_hotels}
          data={HotelsListByBudget}
          location={location}
          gtmConsumerName={GTM_EVENT_CATEGORY.AFFORDABLE}
          translations={pageComponentTranslation.carousel}
        />
      ) : null}

      {HotelsListByDiscount.length ? (
        <CarouselCard
          headline={carouselHeadings.discounted_hotels}
          data={HotelsListByDiscount}
          location={location}
          gtmConsumerName={GTM_EVENT_CATEGORY.DISCOUNT}
          translations={pageComponentTranslation.carousel}
        />
      ) : null}

      {HotelsListByRating.length ? (
        <CarouselCard
          headline={carouselHeadings.high_rated_hotels}
          data={HotelsListByRating}
          location={location}
          gtmConsumerName={GTM_EVENT_CATEGORY.POPULAR}
          translations={pageComponentTranslation.carousel}
        />
      ) : null}

      {internalLinks}
      {contentBlock}

      {faqObjects.length ? (
        <ContentWrapper>
          <TextWrapper>
            <div style={{ marginTop: "8px" }}>
              <FAQ data={faqObjects} title={faqBlockTitle} titleType="h2" />
            </div>
          </TextWrapper>
        </ContentWrapper>
      ) : null}

      {locationCarousels}
      {additionalInternalLinkBlocks}
    </Layout>
  )
}

export default LocationPage
